import { InvalidAssetTypeError, InvalidAssetTypeJSONError } from '../errors';
export var AssetTypeModel;
(function (AssetTypeModel) {
    AssetTypeModel[AssetTypeModel["CreditFlag"] = 64] = "CreditFlag";
    AssetTypeModel[AssetTypeModel["DutyFlag"] = 128] = "DutyFlag";
    AssetTypeModel[AssetTypeModel["GoverningToken"] = 0] = "GoverningToken";
    AssetTypeModel[AssetTypeModel["UtilityToken"] = 1] = "UtilityToken";
    AssetTypeModel[AssetTypeModel["Currency"] = 8] = "Currency";
    AssetTypeModel[AssetTypeModel["Share"] = 144] = "Share";
    AssetTypeModel[AssetTypeModel["Invoice"] = 152] = "Invoice";
    AssetTypeModel[AssetTypeModel["Token"] = 96] = "Token";
})(AssetTypeModel || (AssetTypeModel = {}));
export const hasFlag = (assetType, flag) => (assetType & flag) === flag;
const isAssetType = (assetType) => AssetTypeModel[assetType] !== undefined;
export const assertAssetType = (assetType) => {
    if (!isAssetType(assetType)) {
        throw new InvalidAssetTypeError(assetType);
    }
    return assetType;
};
export const toJSONAssetType = (type) => assertAssetTypeJSON(AssetTypeModel[type]);
const isAssetTypeJSON = (assetType) => AssetTypeModel[assetType] !== undefined;
export const assertAssetTypeJSON = (type) => {
    if (!isAssetTypeJSON(type)) {
        throw new InvalidAssetTypeJSONError(type);
    }
    return type;
};
export const toAssetType = (type) => AssetTypeModel[type];

//# sourceMappingURL=AssetTypeModel.js.map
